import { render, staticRenderFns } from "./HotWordList.vue?vue&type=template&id=99f41882&scoped=true"
import script from "./HotWordList.vue?vue&type=script&lang=js"
export * from "./HotWordList.vue?vue&type=script&lang=js"
import style0 from "./HotWordList.vue?vue&type=style&index=0&id=99f41882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f41882",
  null
  
)

export default component.exports